import React from 'react';

export default function FrozenChannelAlert() {
  return (
    <div
      className={
        'border rounded-lg mx-2 mb-1 px-3 py-2 bg-brand-purple-light relative flex items-center justify-between'
      }
    >
      <p className={'text-xs text-brand-black'}>
        {`This chat channel is now set to read-only mode. You can review the message history, but you won't be able to send new messages.`}
      </p>
    </div>
  );
}
